import {useContext, useMemo} from 'react';
import LocaleContext from './context';
import type {Locale, LocaleComponentName} from '.';
import defaultLocaleData from './zh_CN';
const useLocale = <T extends LocaleComponentName>(
    componentName: T,
    defaultLocale?: Locale[T]
) => {
    const fullLocale = useContext(LocaleContext);

    const getLocale = useMemo(() => {
        const locale = defaultLocale || defaultLocaleData[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...locale,
            ...localeFromContext
        };
    }, [componentName, defaultLocale, fullLocale]);

    const localeCode = useMemo(() => {
        const localeCode = fullLocale?.locale;
        if (fullLocale?.exist && !localeCode) {
            return defaultLocaleData.locale;
        }
        return localeCode;
    }, [fullLocale]);

    return [getLocale, localeCode] as const;
};

export default useLocale;